"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtrasProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class ExtrasProvider {
  constructor() {
    (0, _defineProperty2.default)(this, "extras", []);
  }
  get() {
    return this.extras;
  }
  addExtra(extra) {
    if (!this.extras.find(it => it.key === extra.key)) {
      this.extras.push(extra);
    }
    return this;
  }
}
exports.ExtrasProvider = ExtrasProvider;
//# sourceMappingURL=ExtrasProvider.js.map